import { Vue, Component, Prop } from "vue-property-decorator";
import DashboardOrderSummary from "../dashboardOrderSummary/dashboardOrderSummary";

import MealsCarousel from "../mealsCarousel/mealsCarousel";
import IngredientModal from "../ingredientModal/ingredientModal";
import moment from "moment";
import { Mutation } from "vuex-class";

@Component({ components: { DashboardOrderSummary, MealsCarousel, IngredientModal } })
export default class DashboardTabContent extends Vue {
  @Prop({ default: null }) order: any;
  @Prop({ default: false }) isLastOrder: boolean;

  @Mutation SET_SELECTED_MENU_ID;

  openIngredientModal = false;
  selectedDish = null;

  get filteredDetailMenus() {
    const { details_subscription_menus } = this.order;
    if (this.isLastOrder) {
      return details_subscription_menus.filter((detailMenu) => detailMenu.count);
    }
    return details_subscription_menus;
  }

  get isOrderStatusError() {
    if (!this.isLastOrder) {
      const today = moment();
      if (this.order.status === "active" || this.order.status === "skip_week") {
        const orderCreationDate = moment(this.order.order_creation_date);
        return today.isSameOrAfter(orderCreationDate);
      }
    }
    return false;
  }

  get isActiveAndAfterDeadline() {
    let response = false;
    if (!this.isLastOrder) {
      const today = moment();
      const deadline = moment(this.order.deadline_update_date);
      return today.isSameOrAfter(deadline);
    }
    return response;
  }

  get getOrderDetailsSubscriptionMenus() {
    return this.order.details_subscription_menus;
  }

  get isWeekEditingEnabled() {
    return !this.isLastOrder && !this.isActiveAndAfterDeadline && this.order.status === "active";
  }

  onOpenIngredientsModal(dish) {
    this.selectedDish = dish;
    this.openIngredientModal = true;
  }

  addIngredient() {
    this.$router.push("/mi-menu/ingredientes");
  }

  getCarouselKey(index) {
    return `${this.isLastOrder ? "last-order" : "current-order"}_${index}`;
  }

  toggleIngredientsModal(dish) {
    if (dish) {
      this.selectedDish = dish;
      this.openIngredientModal = true;
    } else {
      this.selectedDish = null;
      this.openIngredientModal = false;
    }
  }

  onAddNewDish() {
    this.$router.push({ name: "subscriptionSettings", query: { isAddingNewDish: "true" } });
    document
      .getElementById("SubscriptionDashboard")
      .scroll({ top: 0, left: 0, behavior: "smooth" });
  }
}
